import * as Constant from '../constants/actionTypes';
import { changeAppRoot } from './app';
import Api, { Action } from '../utils/apiUtil';
import config from '../config';
// import techConfig from '../techConfig';

// let loginCount = techConfig.RetryMax - Constant.ONE;

// export const login = (data, isMobile = true) => {
//   return dispatch => {
//     dispatch(Action(Constant.LOGIN_REQUEST));
//     return Api.jsonService(`${config.serviceApi}MDP/api/users/login`, Constant.POST, data)
//       .then(result => {
//         if (result.Success) {
//           if (!isMobile) {
//             sessionStorage.setItem(Constant.LOGIN_TIME_OUT, false);
//           }
//           const {
//             Payload: { data: payloadData },
//           } = result;
//           dispatch(Action(Constant.LOGIN_SUCCESS, { user: payloadData, login: data }));
//         }
//       })
//       .catch(err => {
//         if (
//           (err.Error && err.Error.message === Constant.LABEL_INVALID_CREDENTIALS) ||
//           loginCount === Constant.ZERO ||
//           !isMobile
//         ) {
//           if (loginCount === Constant.ZERO) {
//             loginCount = techConfig.RetryMax - Constant.ONE;
//           } else {
//             dispatch(Action(Constant.LOGIN_FAIL, err.Error || err));
//           }
//         } else {
//           loginCount -= Constant.ONE;
//           login(data, isMobile);
//         }
//       });
//   };
// };

export const logout = () => {
  return dispatch => {
    dispatch(changeAppRoot(Constant.REGISTER));
    // Fixed: Bug 871368:iOS Login icon click not working after changed password in Server
    // dispatch(Action(types.LOGOUT));
  };
};

export const providerLogin = data => {
  return dispatch => {
    dispatch(Action(Constant.PROVIDER_LOGIN_REQUEST));
    return Api.jsonService(
      `${config.serviceApi}MDP/api/cards/downloadGroupMemberCard`,
      Constant.POST,
      data,
    )
      .then(result => {
        if (result.Success) {
          const {
            Payload: { data: providerData },
          } = result;
          if (providerData.ErrorCode) {
            dispatch(Action(Constant.PROVIDER_LOGIN_FAIL, providerData));
          } else {
            dispatch(Action(Constant.PROVIDER_LOGIN_SUCCESS, result.Payload));
          }
        }
      })
      .catch(err => {
        dispatch(Action(Constant.PROVIDER_LOGIN_FAIL, err.Error || err));
      });
  };
};
export const providerLoginHealthSummary = data => {
  return dispatch => {
    dispatch(Action(Constant.PROVIDER_LOGIN_REQUEST));
    return Api.jsonService(
      `${config.serviceApi}MDP/1UP/downloadMemberHealthSummary`,
      Constant.POST,
      data,
    )
      .then(result => {
        if (result.Success) {
          const {
            Payload: { data: healthSummaryData },
          } = result;
          if (healthSummaryData.ErrorCode) {
            dispatch(Action(Constant.PROVIDER_LOGIN_FAIL, healthSummaryData));
          } else {
            dispatch(Action(Constant.PROVIDER_LOGIN_SUCCESS, result.Payload));
          }
        }
      })
      .catch(err => {
        dispatch(Action(Constant.PROVIDER_LOGIN_FAIL, err.Error || err));
      });
  };
};
